<template>
  <HubContainer id="helpSupportHub">

    <template v-if="atLeastCompanyAdmin && !$store.getters.isBranchContextInventory && company">
      <HubSection large icon="icon/hub/check-pos-status.svg"
                  :title="$t('external_pos_connection.check_external_pos')"
                  :description="$t('external_pos_connection.description')"
                  :buttonAction="goToExternalPosConnection">
      </HubSection>

      <HubSection large icon="icon/hub/pos-help.svg"
                  :title="$t('qr_payment_request.title')"
                  :description="$t('qr_payment_request.description')"
                  :buttonAction="goToqrPayRequest">
      </HubSection>

      <HubSection large icon="icon/hub/support-tools.svg" v-if="payfactoSupport"
                  :title="$t('payfacto_support.title')"
                  :description="$t('payfacto_support.' + payfactoSupport.type)"
                  :buttonAction="goToPayfactoSupportUrl">
      </HubSection>

    </template>
    <!--

        <template v-if="$store.state.contextCompany">
          <Collapse closed dot text="POS">
            <NavigationLink dot @click="$emit('close-menu')" url="/check-external-pos-connection">{{ $t('external_pos_connection.check_external_pos') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/qr-payment-requests">{{ $t('qr_payment_request.title') }}</NavigationLink>
            <PayfactoSupportUrl class="link" dot />
          </Collapse>
        </template>
    -->
  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "posHelpSupportHub",

    components: { HubSection, HubContainer },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "advanced_navigation.help_support";
      this.$store.state.pageIcon = "/icon/info.svg";
    },

    data() {
      return {
        Parameters
      }
    },

    computed: {
      atLeastCompanyAdmin() {
        return this.$store.getters.loggedUserHasCompanyAdmin;
      },
      company() {
        return this.$store.state.contextCompany;
      },
      payfactoSupport() {
        let company = this.$store.state.contextCompany;
        if (company && company.activePOS && company.activePOS[0]) {
          switch(company.activePOS[0]) {
            case "veloce":
              return {
                type: "veloce",
                url: {
                  fr: "documents/iShopFood - Depannage Payfacto V.pdf",
                  en: "documents/iShopFood - Payfacto Troubleshooting V.pdf"
                }
              };
            case "maitre":
              return {
                type: "maitre",
                url: {
                  fr: "documents/iShopFood - Depannage Payfacto MD.pdf",
                  en: "documents/iShopFood - Payfacto Troubleshooting MD.pdf"
                }
              };
            default: {
              return null;
            }
          }
        }

        return null;
      }

    },

    methods: {
      goToExternalPosConnection() {
        this.$router.push(this.$router.buildContext("/check-external-pos-connection"));
      },
      goToqrPayRequest() {
        this.$router.push(this.$router.buildContext("/qr-payment-requests"));
      },
      goToPayfactoSupportUrl() {
        if (this.payfactoSupport) {
          window.open(this.payfactoSupport.url[this.$ts.state.locale]);
        }
      },
    }
  }
</script>